import * as bootstrap from 'bootstrap';
import TomSelect from 'tom-select';
import Helper from './helper';

import.meta.glob([
    '../img/**'
]);

window.TomSelect = TomSelect;

class App {
    constructor() {
        this.init();
    }

    init() {
        this.asyncForms();
        this.autoModals();
        this.cookies();
        this.responsiveEmbeds();
    }

    /**
     * Process asynchronous forms
     */
    asyncForms() {
        let gRecaptchaWidgets = [];

        document.querySelectorAll('.g-recaptcha-widget').forEach(recaptcha => {
            let widgetId = grecaptcha.render(recaptcha.id, {
                'sitekey' : config.recaptcha_site_key
            });

            gRecaptchaWidgets.push(widgetId);
        });

        /**
         * Refresh reCAPTCHA
         */
        let refreshRecaptcha = () => {
            // Check if reCAPTCHA is loaded
            if (typeof grecaptcha === 'undefined') {
                return;
            }

            // Refresh all recaptcha widget instances
            gRecaptchaWidgets.forEach(widgetId => {
                grecaptcha.reset(widgetId);
            });
        }

        setInterval(function() {
            refreshRecaptcha();
        }, 2 * 60 * 1000);

        document.querySelectorAll('.form--async').forEach(form => {
            form.addEventListener('submit', (e) => {
                e.preventDefault();

                // Serialize all form data
                let formData = new FormData(form);

                // Fetch container for the form messages
                let formMessages = form.querySelector('.form-messages');

                // Clear the form errors
                form.querySelectorAll('[data-error]').forEach(errorMessage => {
                    // Clear error message
                    errorMessage.innerHTML = '';

                    // Remove multiple status class
                    errorMessage.classList.remove('multiple');
                });

                // Clear the form messages
                formMessages.replaceChildren();

                Helper.post(form.getAttribute('action'), formData).then(response => {
                    if (response.redirect_url) {
                        // Redirect to the given URL
                        window.location.href = response.redirect_url;
                    }
                    else {
                        // Reset form
                        form.reset();

                        // Refresh reCAPTCHA
                        refreshRecaptcha();

                        formMessages.innerHTML = '<div class="alert alert--' + response.message.type + '"><span>' + response.message.text + '</span></div>';
                    }
                })
                .catch(error => {
                    let statusCode = error.statusCode;

                    switch (statusCode) {
                        case 422:
                            // Set error messages
                            Object.entries(error.response.errors).forEach(([key, errors]) => {
                                // Find the target element with data-error attribute
                                const targetElement = form.querySelector('[data-error="' + key + '"]');

                                if (targetElement === null) {
                                    return;
                                }

                                if (errors.length > 1) {
                                    // Mark container as multiple errors
                                    targetElement.classList.add('multiple');
                                }

                                errors.forEach(function (error) {
                                    // Create a new <span> element
                                    const errorSpan = document.createElement('span');

                                    // Set the text content of the <span>
                                    errorSpan.textContent = error;

                                    // Append the <span> as a child of the target element
                                    targetElement.appendChild(errorSpan);
                                });
                            });
                            break;

                        default:
                            // Show notification
                            alert('Er is iets misgegaan.');
                    }

                    // Refresh reCAPTCHA
                    refreshRecaptcha();

                    // Reject the promise
                    return Promise.reject(error.statusText);
                });
            });
        });
    }

    autoModals() {
        document.querySelectorAll('.modal-auto').forEach(modal => {
            bootstrap.Modal.getOrCreateInstance(modal).show();
        });
    }

    /**
     * Set cookie preferences
     */
    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookies-banner__options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    /**
     * Wrap iframes in a responsive container
     */
    responsiveEmbeds() {
        let wrap = function (toWrap, wrapper) {
            wrapper = wrapper || document.createElement('div');
            toWrap.parentNode.insertBefore(wrapper, toWrap);
            return wrapper.appendChild(toWrap);
        }

        // Responsive embeds
        document.querySelectorAll('iframe:not([class])').forEach(iframe => {
            let wrapper = document.createElement('div');

            wrapper.setAttribute('class', 'ratio ratio-16x9');

            wrap(iframe, wrapper);
        });
    }
}

window.addEventListener('load', () => new App());
